
import React, {useContext} from 'react'
import { observer } from 'mobx-react-lite'
import ActionsByPlatform from './ActionsByPlatform'
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons'
import InfluencerActionPlatform from '../../../../ProjectManager/Campaign/CampaignPageParts/DraftProcessParts/SidebarParts/InfluencerActionPlatform'
import { useNavigate, useParams } from 'react-router-dom'
import { SharedCampaignContext } from '../../../../../contexts/Advertiser/SharedCampaignContext'

export default observer(function ActionInfluencerItem({ influencer }) {
  const { actionsForInfluencer } = useContext(SharedCampaignContext)
  const { id, influencer_id } = useParams()
  const navigate = useNavigate()

  const infActions = actionsForInfluencer(influencer.id)

  return (
    <div className='border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-lg mb-5 bg-white dark:bg-rb-dark-mode'>
      <div className="p-3 flex justify-between items-center flex-grow">
        <div className="flex items-center">
          <img src={influencer.avatar} className='bg-rb-green border-1 border-grey-500 dark:border-rb-dark-mode-lighter rounded-full w-8 h-8 mr-2' />
          <span className='font-bold dark:text-white'>{influencer.username}</span>
        </div>
        <div className="flex gap-2">
          <span className='flex justify-center items-center text-xs w-4 h-4 text-white bg-rb-green p-1 rounded-full'>{infActions.length}</span>
          <button
            className="font-bold dark:text-rb-green"
            style={{ color: '#2CCDB4' }}
            onClick={() => {
              if (!influencer_id) {
                navigate(`/advertiser/campaign_share/${id}/draft_review/participants/${influencer.id}`)
              } else if (influencer_id && +influencer_id !== +influencer.id) {
                navigate(`/advertiser/campaign_share/${id}/draft_review/participants/${influencer.id}`)
              } else {
                navigate(`/advertiser/campaign_share/${id}/draft_review`)
              }
            }}
          >
            {influencer_id && +influencer_id === +influencer.id ? <ChevronUp /> : <ChevronDown />}
          </button>
        </div>
      </div>
      <div>
        {
          (influencer_id && +influencer_id === +influencer.id) && (
            <>
              <div className='border-t-1 border-rb-widget-border dark:border-rb-dark-mode-lighter flex gap-2'>
                  {
                    influencer.platforms.map((platform, index) => <InfluencerActionPlatform key={index} platform={platform} influencer={influencer}/>)
                  }
              </div>
              {
                influencer.selectedPlatform && (
                  <div className="border-t-1 border-rb-widget-border dark:border-rb-dark-mode-lighter">
                    <ActionsByPlatform platform={influencer.selectedPlatform}/>
                  </div>
                )
              }
            </>
          )
        }
      </div>
    </div>
  )
})